import React from "react";
import {
  Container,
  FileInfo,
  Content,
  // Preview,
} from "./styles";
import { ArchiveOutlined } from "@mui/icons-material";
import { Button } from "../../../assets/global/globalStyles";

/**
 * @param props
 * @param {String} props.files
 * @param {Function} props.onDelete
 * @param {Function} props.onSubmit
 */
export default function FileList({ files, onDelete, onSubmit }) {
  return (
    <Container>
      <Content>
        {files.map((uploadedFile) => (
          <li key={uploadedFile.id}>
            <FileInfo>
              <ArchiveOutlined
                style={{
                  color: " var(--color)",
                  marginRight: 10,
                  width: "25px",
                  height: "25px",
                }}
              />
              <div>
                <strong>{uploadedFile.name}</strong>
                <span>
                  {uploadedFile.readableSize}
                  <button onClick={() => onDelete(uploadedFile.id)}>
                    Exluir
                  </button>
                </span>
              </div>
            </FileInfo>
          </li>
        ))}
      </Content>
      <Button typeName="warning" onClick={onSubmit}>
        enviar
      </Button>
    </Container>
  );
}
